module.exports = __webpack_public_path__ + "static/media/zip-modal-thumb-up.e5ddd3e7.svg";